import styled from 'styled-components';
import { colorBrandPrimary300 } from 'constants/colors';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  padding: 0 16px;
  color: ${colorBrandPrimary300};
`;

export const HeaderLogo = styled.img`
  height: 30px;
  max-width: 70%;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
`;

export const AuthWrapper = styled.div`
  margin: 16px;
`;
